import '../../styles/web-components/selected-store.scss';
import { selectedStoreState, sharedStoreDataMapping } from '../services/store.service';
import { toRawPhoneNumber, transformStorePhone } from '../helpers/transformations';
class SelectedStore extends HTMLElement {
    dropdown;
    selectedStoreUnsub;
    constructor() {
        super();
        this.addEventListener("mouseover", () => this.showInfoDropdown());
        this.addEventListener("focusin", () => this.showInfoDropdown());
        this.addEventListener("focusout", () => this.hideInfoDropdown());
        this.addEventListener("mouseleave", () => this.hideInfoDropdown());
    }
    connectedCallback() {
        this.dropdown = this.querySelector(".selected-store__dropdown");
        this.selectedStoreUnsub = selectedStoreState.subscribe((store) => {
            if (store) {
                this.populateStoreInfo(store);
            }
        });
    }
    disconnectedCallback() {
        this.selectedStoreUnsub?.();
    }
    populateStoreInfo(store) {
        const mainLink = this.querySelector(".selected-store__main-link");
        if (mainLink) {
            mainLink.href = "#";
            mainLink.role = "button";
        }
        const storeNameEl = this.querySelector('.selected-store__store-name');
        if (storeNameEl) {
            storeNameEl.textContent = store.SHOPIFY_DISPLAY_NAME;
        }
        const { address, city, storeHref } = sharedStoreDataMapping(store);
        this.renderDropdown(store, address, city, storeHref);
    }
    showInfoDropdown() {
        if (this.dropdown && !this.isDropdownShown()) {
            this.dropdown.style.display = "block";
        }
    }
    hideInfoDropdown() {
        if (this.dropdown && this.isDropdownShown()) {
            this.dropdown.style.display = "none";
        }
    }
    isDropdownShown() {
        return this.dropdown && this.dropdown.style.display !== 'none';
    }
    renderDropdown(store, address, city, storeHref) {
        if (this.dropdown) {
            this.dropdown.innerHTML = `
        <div class="selected-store-dropdown__store-info">
          <p class="selected-store-dropdown__store-name">${store.SHOPIFY_DISPLAY_NAME}</p>
          <p class="selected-store-dropdown__store-address">
            <span>${address}</span>
            <span>${city}</span>
          </p>
          <a class="selected-store-dropdown__store-phone" href="tel:${toRawPhoneNumber(store.PHONE)}">${transformStorePhone(store.PHONE)}</a>
          <p class="selected-store-dropdown__store-hours">${parseStoreHours(store)}</p>
        </div>
        <a class="selected-store-dropdown__store-link" href="${storeHref}">Shop This Store</a>
        <a class="selected-store-dropdown__store-link" href="/blogs/store-locations">Find a Different Store</a>
      `;
        }
    }
}
/**
 * attempts to handle store hours with inconsistent structures
 * (separators include commas, pipes, forward slashes, and even three spaces)
 */
function parseStoreHours(store) {
    if (store.STORE_HOURS) {
        return store.STORE_HOURS.split(/,|\||\/|\s{3}/gm).map(sh => `${sh.trim()}<br/>`).join("");
    }
    else {
        return "";
    }
}
if (!window.customElements.get("selected-store")) {
    customElements.define("selected-store", SelectedStore);
}
